import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import Axios from "@/lib/axios-instance";
import useOnboardingData from "@/store/onboarding-data";

type ResponseType = {
    data: unknown;
};

type ErrorResponse = {
    response?: {
        data?: {
            meta?: {
                code: number;
                message: string;
            };
        };
    };
    message?: string; // Fallback for network errors
};

export const paidUser = async () => {
    try {
        const response = await Axios.put("/users/paid-user", {});
        return response.data;
    } catch (err: unknown) {
        const error = err as ErrorResponse;
        if (error.response) {
            throw new Error(`${error.response.data?.meta?.message || "An error occurred"}`);
        }
        throw new Error(error.message || "Network Error");
    }
};

export const usePaidUser = () => {
    const queryClient = useQueryClient();
    const { setIsStep3Complete } = useOnboardingData();
    return useMutation<ResponseType, Error>({
        mutationFn: () => paidUser(),
        onSuccess: () => {
            setIsStep3Complete(true);
            toast.success("Basic Setup Completed");
            queryClient.refetchQueries({ queryKey: ["check_user"] });
        },
        onError: (error) => {
            toast.error("Payment Failed.", { description: error.message });
        },
    });
};
